import { Component, OnInit, ViewChild } from '@angular/core';
import { ServiceStock } from '../service-stock.service';
import { gotxModalComponent } from '../gotxModal/gotxModal.component';
import { MarketWatchService } from '../market-watch.service';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { SocketioService } from '../socketio.service';
import { NotificationService } from '../notification.service';
import { LocationStrategy } from '@angular/common';
import { IndexList } from 'src/app/user-preference.model';
import { UserPreferenceService } from '../user-preference.service';
import { ProductComponent } from '../gotx/components/Product/Product.component';
import { filter } from 'rxjs/operators';
import { constants } from 'buffer';
import { CONSTANTS } from '../constants.model';
// declare var $: any;

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  @ViewChild('cstmProduct', { static: false }) cstmProduct: ProductComponent;
  selectedMenu = '';
  menu_model_header = '';
  //marketPhase = '';
  marketPhase:any;
  //marketPhase= new Map();
  marketPhaseEquity:any;
  marketPhaseComderv:any;
  marketPhaseFutopt:any;
  displayProduct = '';
  mfequityderivative = '';
  mfcommodity = '';
  mfequity = '';
  mfall = '';
  totalVolume = '';
  totalTurnOver = '';
  indxList: Map<number, any> = new Map<number, any>();
  indxListMaster:{indexName:string,key:number}[]=[];
  myProduct = [];
  sysDateTime: Date = new Date();
  firstIndx: number = 0;
  secondIndx: number = 0;
  loadMW: boolean = false;
  intervalId;
  productValue = [];
  exchangeValue =[];
  productMapFlag = '';
  stockMasterInit = true;
  productHasEquity: boolean = false;
  

  constructor(private services: ServiceStock, private socketio: SocketioService, private marketService: MarketWatchService,
    private httpClient: HttpClient, private notifyService: NotificationService, private location: LocationStrategy, private indexList: IndexList, private userPreferenceService: UserPreferenceService) {
    //Disable BACK Button
    history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
  }

  ngOnInit() {
    this.downloadData();
  }

  initData() {
    this.getIndexMaster(); // Index Master Data
    this.getIndexInitData(); // Index Initial Data
    this.getIndex(); // Index Market Data
    this.getIndexDetails(); // Index Market Data
    this.getMarketStats(); // Market Statistics
    this.getMarketPhase(); // Market Phase Details

    this.notifyService.getNotifications(this.services.dataStore.getData("notificationID")); // Notification Listen
    this.sysDateTime = new Date();
    if (this.services.dataStore.getData("sysDate") != null)
      this.sysDateTime = new Date(this.services.dataStore.getData("sysDate"));

    if (this.services.dataStore.getData("sysTime") != null) {
      let time = this.services.dataStore.getData("sysTime").split(":");
      this.sysDateTime.setHours(Number(time[0]));
      this.sysDateTime.setMinutes(Number(time[1]));
      this.sysDateTime.setSeconds(Number(time[2]));
    }

    this.intervalId = setInterval(() => {
      this.sysDateTime = new Date(this.sysDateTime.getTime() + 1000);
    }, 1000);

   // this.marketPhase = "TRADING";
   //console.log("PHASE this data",this.services.dataStore.getData("marketPhase"));
    if (this.services.dataStore.getData("marketPhase") != null){
      this.marketPhase = this.services.dataStore.getData("marketPhase");
      this.marketPhaseEquity = "EQUITY: " + this.marketPhase.EQUITY;
      this.marketPhaseFutopt = "FUTOPT: " +this.marketPhase.FUTOPT;
      this.marketPhaseComderv = "COMDERV: " + this.marketPhase.COMDERV;
    }
      //this.marketPhase = {DEBT: "Regular Trading",EQUITY: "Regular Trading",FUTOPT: "Regular Trading"};
      this.services.dataStore.currentMessage.subscribe(message => {
        this.displayProduct = message;
        });

        //console.log("PHASE this displayProduct",this.displayProduct);
        if(this.displayProduct == "FUTOPT"){
          //this.mfequityderivative = this.marketPhaseEquity +" / "+ this.marketPhaseFutopt;
          this.mfequityderivative = this.marketPhaseFutopt;
          this.marketPhase = this.mfequityderivative;
        }else if (this.displayProduct == "COMDERV"){
          this.mfcommodity = this.marketPhaseComderv;
          this.marketPhase = this.mfcommodity;
        }else if(this.displayProduct == "EQUITY"){
          this.mfequity = this.marketPhaseEquity;
          this.marketPhase = this.mfequity;
        }else{
          this.mfall =  this.marketPhaseEquity +"/"+ this.marketPhaseFutopt+"/"+ this.marketPhaseComderv ;
          this.marketPhase = this.mfall;
        }
    
    this.totalVolume = "";
    if (this.services.dataStore.getData("totalVolume") != null)
      this.totalVolume = this.services.dataStore.getData("totalVolume");

    this.totalTurnOver = "";
    if (this.services.dataStore.getData("totalTurnOver") != null)
      this.totalTurnOver = this.services.dataStore.getData("totalTurnOver");
    this.loadMW = true;

    this.socketio.socketConnected.subscribe(connected => {
      if (connected) {
        this.notifyService.notificationSubs(this.services.dataStore.getData("notificationID")); // Notification Subs
      }
    });

    // setTimeout(() => {
    // let notifyMSg = "UNQ.225100931GLHD06GJO#EQORADNO~2022-10-28 12:08:34.078893~2022-10-28 12:05:36.229612~225100G003299~EXM1666933653302~0~225100~0~0~960000415~5~ES~CTG~1~2~1~1790000~0~0~20~20~0~0~0~ ~I~0~20221028~0~0~0~~~1~20221028~184000000~                    ~20221028~120832817186~0~~#";
    // this.notifyService.handleNotification(notifyMSg);

    // // notifyMSg = "UNQ.225000860QNJLIBI0X#EQORMONO~2022-11-07 20:21:48.919284~2022-11-07 20:09:45.864147~22500086G002086~O0CJ3XtIvEsQ~0~22500086~0~0~960000355~5~ES~CTG~1~2~1~2907000~0~15~15~0~0~0~ ~I~0~20221107~0~0~~~20221107~202148905~20221107~202148912230~0~~#";
    // this.notifyService.handleNotification(notifyMSg);
    // // let notifyMSg = "UNQ.22500086PMQPLLOWN2#EQORARNO~2022-11-10 13:34:13.931693~2022-11-10 13:30:51.296025~22500086G002102~O0CLDAuQHVaK~0~22500086~0~0~960000415~5~ES~CTG~1~2~1~1613000~0~0~15~0~0~0~0~ ~I~8~20221110~0~14064~8~~0~0~~20221110~133413901~~20221110~133413922793~60~Invalid TIF (OPG not permitted outside opening auction call)~E~0~~#";
    // this.notifyService.handleNotification(notifyMSg);
    // }, 5000);
    // notifyMSg = "UNQ.22500086R2NWJC2QZH#EQORARNO~2022-11-10 15:44:06.993545~2022-11-10 15:43:12.334309~22500086G002104~~0~22500086~0~0~960000991~5~ES~CTG~1~2~2~100000~0~0~10~0~0~0~0~ ~I~0~0~0~7048~8~~0~0~~20221110~0~~20221110~154406983858~0~I~0~~#"
    // this.notifyService.handleNotification(notifyMSg);

    // //rejected Order
    // let notifyMSg2 = "UNQ.225000963ZYVM2N1RL#EQORRJNO~2022-11-09 16:10:07.713715~2022-11-09 16:08:42.803490~22500096G003170~O0CG73QBGK7t~Test~22500096~0~0~5~CTG~E~14002~1~0~0~0~~20221109~161007692~20221109~161007705462~53~Order not found (too late to cancel or unknown order)~~#";
    // this.notifyService.handleNotification(notifyMSg2);

    // //reject
    // let notifyMag = "UNQ.22500086362U1FH0MN#EQORRJNO~2022-11-09 16:59:55.670704~2022-11-09 16:59:25.333126~22500086G002096~O0CKUgSkDCyP~0~22500086~0~0~5~CTG~I~7001~2~0~0~2398316100000~~0~0~20221109~165955653373~0~0~~#"
    // this.notifyService.handleNotification(notifyMag);


    // setTimeout(() => {
    //   this.notifyService.notificationMessage("Mirsha");
    //   this.notifyService.notificationMessage("10/21/2022 10:05:21 Exchange Time: [10:05:00] EQUITY LIMIT Order Confirmed - KSE ExchangeOrderNo : EXM1666312341874 & IntellectOrderNo : 161294221 DELIVERY AIRPORT BUY 100 @ 5.0000 (DAY) for Client M19004");

    //   let row = 1;
    //   setInterval(() => {
    //     this.notifyService.notificationMessage("Mirsha" + row++);
    //   }, 3000);
    // }, 2000);


    // this.totalVolume = "1512";
    // this.totalTurnOver = "2032";

    // setInterval(() => {
    //   let vol = parseInt(this.totalVolume);
    //   vol += this.getRandomInt(15);
    //   this.totalVolume = vol.toString();

    //   let turn = parseInt(this.totalTurnOver);
    //   turn += this.getRandomInt(10);
    //   this.totalTurnOver = turn.toString();
    // }, 1000);
  }

 /* loginData() {
    this.httpClient.get("assets/config/stockMaster.json").subscribe(data => {
      // console.log(data);
      this.services.dataStore.setStockMaster(data);

      this.services.dataStore.setWatchListMap("CSE30", cse30Symbols);
      this.services.dataStore.setWatchListMap("GOTXList", gotxListSymbols);
      this.services.dataStore.setWatchListMap("CSCX", cscxSymbols);
    })
    let cse30Symbols = [
      {
        "Symbol": "ABBANK",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "ACI",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "AFTABAUTO",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "AMCL(PRAN)",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "APEXADELFT",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "ARAMIT",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "BATASHOE",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "LINDEBD",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "DHAKABANK",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "EXIMBANK",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "GQBALLPEN",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "GREENDELT",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "HEIDELBCEM",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "IDLC",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "IFIC",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "ISLAMIBANK",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "MEGHNACEM",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "NBL",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "NCCBANK",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "PADMAOIL",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "PRAGATIINS",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "PRIMEBANK",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "PUBALIBANK",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "SOUTHEASTB",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "SQUARETEXT",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "SQURPHARMA",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "USMANIAGL",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "UTTARABANK",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "UTTARAFIN",
        "Exch": "CTG",
        "Product": "EQUITY"
      }
    ];

    let cscxSymbols = [
      {
        "Symbol": "1JANATAMF__NR",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "1STPRIMFMF__NR",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "8THICB__NR",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "AAMRANET__NR",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "AAMRATECH__NR",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "ABB1STMF__NR",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "ABBANK__NR",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "ACFL__NR",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "ACI__NR",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "ACIFORMULA__NR",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "ACMELAB__NR",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "ACTIVEFINE__NR",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "ADNTEL__NR",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "ADVENT__NR",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "AFCAGRO__NR",
        "Exch": "CTG",
        "Product": "EQUITY"
      }
    ];

    let gotxListSymbols = [
      {
        "Symbol": "ABBNK",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "ACI",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "AFAUT",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "APXFW",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "ARMIT",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "BATA",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "BDCOM",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "LINDEBD",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "BXPH",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "CNFCM",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "DHBNK",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "EXIMB",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "GDI",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "GQBAL",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "HBCM",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "IDLC",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "IFIC",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "MGHCM",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "NBL",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "NCCBL",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "PDOIL",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "PMBNK",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "PRAGI",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "PUBNK",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "SEBNK",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "SINGR",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "SQPH",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "SQTEX",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "UBL",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "UFIL",
        "Exch": "CTG",
        "Product": "EQUITY"
      },
      {
        "Symbol": "UGLAS",
        "Exch": "CTG",
        "Product": "EQUITY"
      }
    ]

    this.services.dataStore.exchProduct = {
      "CTG": [
        "EQUITY",
        "DEBT"
        // ],
        // "ABC": [
        //     "pdct1",
        //     "pdct2"
      ]
    };
    // "regExchProduct":{"CTG":["EQUITY","DEBT"]}
    let regExchangeData = [{ "exch": "CTG", "dispExch": "CSE" }];
    this.services.dataStore.setExchangeData(regExchangeData);

    this.services.dataStore.setData("defaultIndex", "CSE30,CSCX");
    localStorage.setItem('THEME_MODE', 'light');
    this.services.theme.setDarkThemeMode();
    let watchLists = ["CSE30", "GOTXList", "CSCX"];
    watchLists.forEach(el => {
      this.services.dataStore.addWatchlist(el);
    });
    // this.services.dataStore.setWatchListMap("CSE30", cse30Symbols);
    // this.services.dataStore.setWatchListMap("GOTXList", gotxListSymbols);
    // this.services.dataStore.setWatchListMap("CSCX", cscxSymbols);

    this.services.dataStore.setInvestorList(["22510001"]);
    this.services.dataStore.setData("notificationID", "UNQ.225100YUTXKOQ2KODP.OMS");
    this.services.dataStore.setData("userID", "22510001");
    this.services.dataStore.setData("exchangeID", "CTG");
    this.services.dataStore.setData("productID", "EQUITY");
    this.services.dataStore.setData("marginGroupNo", 1);
    this.services.dataStore.setData("boardID", "NR");
    this.services.dataStore.setData("sysDate", "2022-04-19");
    this.services.dataStore.setData("sysTime", "13:00:00");
    this.services.dataStore.setParticipantIDList("KABIR");
    localStorage.setItem('userID', "22510001");
    this.services.authService.newUserValue = "22510001";
    this.services.dataStore.setData('userName', "22510001");
    this.services.dataStore.setData('lastloginDate', 20221010);
    this.services.dataStore.setData('lastloginTime', 192510134);

    let lastdate = 20221010 + "";
    let lastTime = 192510134;
    let lastLogin = "";
    try {
      if (lastdate != null && typeof lastdate != "undefined") {
        lastLogin = lastdate.slice(6, 8).concat("/").concat(lastdate.slice(4, 6)).concat("/").concat(lastdate.slice(0, 4));
      }
      if (lastTime != null) {
        lastLogin += " "
        lastLogin += this.services.timePipe.transform(lastTime);
      } else {
        lastLogin = "-";
      }
    } catch (error) {
      lastLogin = "-";
    }

    this.services.dataStore.setData('lastloginDateAndTime', lastLogin);

    let nodeDetails = {
      url: "202.53.164.184",//"172.16.102.238",//,
      port: "24010",//"49485",//"24010",//"49384",
      path: "/oms_stream_ipms",
      reAttempts: Number("5"),
      timeout: Number("1000")
    }

    // this.services.dataStore.setData("nodeDetails", nodeDetails);
    // this.socketio.totalReconnectAllowed = nodeDetails.reAttempts + 1;
    // this.socketio.totalAttempts = 0;
    // this.socketio.setupSocketConnection();

    setTimeout(() => {
      this.initData();
      // this.services.http.hideSpinner();
    }, 500);
  }*/

  downloadData() {
    /************************************************************
    * 
    * //for testing - delete below
    * 
    *************************************************************/
   // this.loginData();
    /************************************************************
    * 
    * //for testing - delete above
    * 
    *************************************************************/
    this.services.http.showSpinner();
    let inputMap = new Map();
    // inputMap.clear();
    this.services.http.fetchApi('/auth/data', 'GET', inputMap).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        let resObj = res['response'];
        this.productValue = resObj.regProduct;
       //this.productValue =["EQUITY","COMDERV"];
        this.exchangeValue = resObj.regExchangeList[0];
        this.services.dataStore.setExchProduct(resObj.regExchProduct);


       //added by pooja starts
       if(resObj.regProduct.length == 1 && resObj.regProduct.includes("COMDERV")){
        var displayProduct = "COMDERV";
        this.services.dataStore.changeMessage(displayProduct);
       }else if(resObj.regProduct.length == 1 && (resObj.regProduct.includes("FUTOPT"))){
        var displayProduct = "FUTOPT";
        this.services.dataStore.changeMessage(displayProduct);
       }else if((resObj.regProduct.includes("COMDERV")) && (resObj.regProduct.includes("FUTOPT"))){
        var displayProduct = "ALL";
        this.services.dataStore.changeMessage(displayProduct);
       }else{
        var displayProduct = "EQUITY";
        this.services.dataStore.changeMessage(displayProduct);
       }
      //added by pooja ends 

        this.services.dataStore.setProductSource(resObj.productoptiontype);
        //this.services.dataStore.setProductDerivative(resObj.productoptiontype);
       //this.services.dataStore.setExchProduct({CTG: ["EQUITY","COMDERV"]});
        this.services.dataStore.setExchangeData(resObj.regExchangeData);
        this.services.dataStore.setInvestorList([resObj.userID.toUpperCase()]);
        this.services.dataStore.setData("userID", resObj.userID.toUpperCase());
        this.services.dataStore.setmarginGroupList(resObj.marginGroupList);
        localStorage.setItem('userID', resObj.userID.toUpperCase());
        this.services.authService.newUserValue = resObj.userID.toUpperCase();
        this.services.dataStore.setData('userName', resObj.userID.toUpperCase());
        this.services.dataStore.setData('lastloginDate', resObj.logonDate);
        this.services.dataStore.setData('lastloginTime', resObj.logonTime);
        this.services.dataStore.setData("notificationID", resObj.notificationID);

        let lastdate = resObj.logonDate + "";
        let lastTime = resObj.logonTime;
        let lastLogin = "";
        try {
          if (lastdate != null && typeof lastdate != "undefined") {
            lastLogin = lastdate.slice(6, 8).concat("/").concat(lastdate.slice(4, 6)).concat("/").concat(lastdate.slice(0, 4));
          }
          if (lastTime != null) {
            lastLogin += " "
            lastLogin += this.services.timePipe.transform(lastTime);
          } else {
            lastLogin = "-";
          }
        } catch (error) {
          lastLogin = "-";
        }
        this.services.dataStore.setData('lastloginDateAndTime', lastLogin);

        this.services.dataStore.setData("sysDate", resObj.sypDateStr);
        this.services.dataStore.setData("sysTime", resObj.systemTime);
        this.services.dataStore.setParticipantIDList(resObj.participantid);
        inputMap.clear();

        //Added new request to get product --Starts
        inputMap.set('Body.exchange', resObj.exchangeID);
            //inputMap.set('Body.product', resObj.productID);
            var productRequest = "";
            this.productValue = this.productValue.filter(e => e !== "DEBT");
            for (let i = 0; i < this.productValue.length; i++) {
              productRequest += this.productValue[i];
              if (i < this.productValue.length - 1) {
                productRequest += "#";
              }
          }
          
          inputMap.set('Body.product',productRequest);
          
            this.services.http.fetchApi('/masters/derivativeProduct', 'POST', inputMap).subscribe(
              async (httpResponse: HttpResponse<any>) => {
                var productForDerivative = [];
                
                var res = httpResponse.body;
                //res.response = [{product: "EQUITY"},{product: "CFT"}, {product: "COT"}];
                //res.response = ["EQUITY","CFT","COT"];
                if(this.productValue.length == 1 && this.productValue.includes("EQUITY") ){
                  productForDerivative = ["EQUITY"];
                }else{
                  productForDerivative = this.services.dataStore.setProductForDerivative(res.response);
                }
                this.myProduct = productForDerivative;
                //console.log("myproduct during setting",this.myProduct);
                this.services.dataStore.setProductDerivative(productForDerivative);
                inputMap.clear();

        //Added new request to get product --Ends

        inputMap.set('Body.userName', resObj.userID.toUpperCase());
        //
        this.services.UserPreference.userName = resObj.userID.toUpperCase();  // **UserPreference
        //
        //console.log("product for mdentrytype,,,,...",resObj.regProduct);
            if (resObj.regProduct.includes("EQUITY")) {
               inputMap.set("Body.mDEntryType", "0");
            } else if (resObj.regProduct.includes("COMDERV")) {
                inputMap.set("Body.mDEntryType", "C");
            } else if (resObj.regProduct.includes("FUTOPT")) {
                inputMap.set("Body.mDEntryType", "F");
            } else {
                inputMap.set("Body.mDEntryType", "");  // default empty if unknown
            }
        this.services.http.fetchApi('/masters/download', 'POST', inputMap).subscribe(
          async (httpResponse: HttpResponse<any>) => {
            var res = httpResponse.body;
            let resObj = res['response'];
            //console.log("PHASE from donwload",resObj.marketPhase);
            this.services.dataStore.setData("marketPhase", resObj.marketPhase);
            this.services.dataStore.setData("exchangeID", resObj.exchangeID);
            this.services.dataStore.setData("productID", resObj.productID);
            this.services.dataStore.setData("boardID", resObj.boardID);
            this.services.dataStore.setData("totalTrades", resObj.totalTrades);
            this.services.dataStore.setData("totalVolume", resObj.totalVolume);
            this.services.dataStore.setData("totalTurnOver", resObj.totalTurnOver);
            // UserPreference
            // this.services.UserPreference.userName = resObj.userID;  // ref. above **
            this.services.UserPreference.language = resObj.language || 'en';
            this.services.UserPreference.themeName = resObj.theme || 'classicBlue';
            this.services.UserPreference.tickerSpeed = resObj.tickerSpeed || 0;
            this.services.UserPreference.selectedStock = (resObj.tickerValue && JSON.parse(resObj.tickerValue)) || JSON.parse('{"stock":"MYPORTFOLIO","filter":[]}'); // 'MYPORTFOLIO'
            this.services.UserPreference.marketWatchColumn = null;
            this.services.UserPreference.marketMatrixDepthDetails = null;    
            this.services.MarketWatchPreferenceInfo.marketWatchPreferenceInfo = JSON.parse(resObj.marketWatchPreferenceInfo);
            if (this.services.MarketWatchPreferenceInfo.marketWatchPreferenceInfo != null) {
              this.services.UserPreference.userPreference.DefaultList = this.services.MarketWatchPreferenceInfo.marketWatchPreferenceInfo['DefaultList'];
              this.services.UserPreference.userPreference.preferredList = this.services.MarketWatchPreferenceInfo.marketWatchPreferenceInfo['preferredList'];
              this.services.UserPreference.userPreference.orderentry = this.services.MarketWatchPreferenceInfo.marketWatchPreferenceInfo['orderentry'];
              this.services.UserPreference.userPreference.indexinfo = this.services.MarketWatchPreferenceInfo.marketWatchPreferenceInfo['indexinfo'];
              this.services.UserPreference.userPreference.landingPage = this.services.MarketWatchPreferenceInfo.marketWatchPreferenceInfo['landingPage'];
            }
            // console.log('MarketWatchPreferenceInfo', this.services.MarketWatchPreferenceInfo.marketWatchPreferenceInfo);
            //
            inputMap.clear();
            inputMap.set('Body.exchange', resObj.exchangeID);
            //inputMap.set('Body.product', resObj.productID);
            var productRequest = "";
            this.productValue = this.productValue.filter(e => e !== "DEBT");
            for (let i = 0; i < this.productValue.length; i++) {
              productRequest += this.productValue[i];
              if (i < this.productValue.length - 1) {
                productRequest += "#";
              }
          }
          
            inputMap.set('Body.product', productRequest);
            this.services.http.fetchApi('/masters/stock', 'POST', inputMap).subscribe(
              async (httpResponse: HttpResponse<any>) => {
                var res = httpResponse.body;
                this.services.dataStore.setStockMaster(res.response);
                inputMap.clear();
             
                this.services.http.fetchApi('/masters/nodedetails', 'GET', inputMap).subscribe(
                  async (httpResponse: HttpResponse<any>) => {
                    var res = httpResponse.body;
                    let resObj = res['response'];
                    let nodeServers = resObj.nodeRecRespList
                    var nodeIp = "";
                    var nodePort = "";
                    nodeServers.forEach(element => {
                      if (element.nodeId == resObj.primaryNode) {
                        nodeIp = element.nodeIp;
                        nodePort = element.nodePort;
                      }
                    });
                    let nodeDetails = {
                      url: nodeIp,
                      port: nodePort,
                      path: "/" + resObj.contextPath,
                      reAttempts: Number(resObj.reconnectionAttempts),
                      timeout: Number(resObj.nodeConnTimeout)
                    }
                    this.services.dataStore.setData("nodeDetails", nodeDetails);
                    this.socketio.totalReconnectAllowed = nodeDetails.reAttempts + 1;
                    this.socketio.totalAttempts = 0;
                    this.socketio.setupSocketConnection();

                    inputMap.clear();
                    var productRequest = "";
            this.productValue = this.productValue.filter(e => e !== "DEBT");
            for (let i = 0; i < this.productValue.length; i++) {
              productRequest += this.productValue[i];
              if (i < this.productValue.length - 1) {
                productRequest += "#";
              }
          }
                    inputMap.set('Body.product',productRequest);
                    this.services.http.fetchApi('/default/masters', 'POST', inputMap).subscribe(
                      async (httpResponse: HttpResponse<any>) => {
                        var res = httpResponse.body;
                        //console.log("resp index",res);
                        this.indxListMaster = res.response.indexSymbolArray;
                        this.services.dataStore.setData("indxListMaster", this.indxListMaster);
                        //console.log('this.product',this.myProduct);
                        //console.log('this.product[0]',this.myProduct[0]);
                        if(this.myProduct[0] == "COMDERV" || this.myProduct[0] == "FUTCOM" || this.myProduct[0] == "OPTCOM"){
                        //if(this.myProduct[0] == "FUTSTK" || this.myProduct[0] == "OPTSTK"){
                          this.indxListMaster = this.indxListMaster['COMDERV'];
                        }else{
                          this.indxListMaster = this.indxListMaster['EQUITY'];
                        }

                        this.firstIndx = this.indxListMaster[0].key;
                        this.secondIndx = this.indxListMaster[1].key;
                        //console.log("resp index EQUITY",this.indxListMaster['EQUITY']);
                        //console.log("this.firstIndx",this.firstIndx,"this.secondIndx",this.secondIndx);
                        
                        // For Index settings **UserPreference
                       //this.services.dataStore.setData("defaultIndex", this.services.UserPreference.userPreference.indexinfo.join() || res.response.defaultIndex);
                        this.services.dataStore.setData("defaultIndex", res.response.defaultIndex);
                        
                        // For theme settings **UserPreference
                        localStorage.setItem('THEME_MODE', this.userPreferenceService.getIwsTheme() || res.response.defaultTheme);
                        this.services.theme.setDarkThemeMode();

                        // For Lang settings **UserPreference
                        this.services.translate.use(this.userPreferenceService.getIwsLang() || this.services.UserPreference.language);

                        // console.log(this.services.dataStore.getData("defaultIndex"));
                        res.response.watchLists.forEach(el => {
                          this.services.dataStore.addWatchlist(el);
                          this.services.dataStore.setWatchListMap(el, res.response[el]);
                          ;
                        });

                        // For Custom watchlist settings **UserPreference
                        this.services.UserPreference.userPreference.preferredList.forEach(item => {
                          if (this.services.MarketWatchPreferenceInfo.marketWatchPreferenceInfo[item] != null) {
                            this.services.dataStore.addWatchlist(item, true, (item == this.services.UserPreference.userPreference.DefaultList));
                            this.services.dataStore.setWatchListMap(item, this.services.MarketWatchPreferenceInfo.marketWatchPreferenceInfo[item]);
                          }
                        });

                        this.services.http.sessionValid = true;
                        this.services.http.loggedIn = true;

                        this.initData();
                      },
                      
                      async (httpError) => {
                        var err = httpError['error']
                        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
                        }

                        this.services.http.hideSpinner();
                        // document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
                      }
                    );
                  },
                  async (httpError) => {
                    var err = httpError['error']
                    if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
                    }
                    // document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
                    this.services.http.hideSpinner();
                  }
                );
              },
              async (httpError) => {
                var err = httpError['error']
                if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
                }
                // document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
                this.services.http.hideSpinner();
              }
            );
          },
              async (httpError) => {
                var err = httpError['error']
                if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
                }
                // document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
                this.services.http.hideSpinner();
              }
            );
          },
          async (httpError) => {
            var err = httpError['error']
            if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
              // if (err['ErrorElementPath'] == 'userName') {
              //   this.txtUserName.setError(err['ErrorDescription']);
              // }
            }
            // document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
            this.services.http.hideSpinner();
          }
        );
      },
      async (httpError) => {
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
        }
        // document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
        this.services.http.hideSpinner();
      }
    );
  }
  
  //For Master Stock in request based on product request
   
  /*additionalStockDownload(){
    let inputMap = new Map();
   
    this.productValue = this.productValue.filter(item => item !== this.productMapFlag);
    
    for (let i = 0; i < this.productValue.length; i++) {
      
      inputMap.set('Body.exchange', this.exchangeValue);
	    inputMap.set('Body.product', this.productValue[i]);

	    this.services.http.fetchApi('/masters/stock', 'POST', inputMap).subscribe(
              async (httpResponse: HttpResponse<any>) => {
                var res = httpResponse.body;
                console.log("inside additionalStockDownload response",res.response);

                this.services.dataStore.setStockMaster(res.response);
                inputMap.clear();
    }
    );
    }
  }*/
  
  

  handleSelectedMenu(event, size) {
    this.selectedMenu = event;
    this.menu_model_header = event;
    if (this.selectedMenu == "Notification") {
      this.notifyService.notifyCount = 0;
    }
    const modalRef = this.services.openModal(gotxModalComponent, size, null, this.selectedMenu)
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
    this.socketio.disconnect();
  }

  getIndexMaster() {
    this.marketService.getIndexMaster().subscribe((data: any) => {
      data.forEach(obj => {
        obj.indexValue = 0;
        obj.changePercent = 0;
        obj.netChangeValue = 0;
        obj.indexColor = "default";
        this.indxList.set(obj.indexId, obj)
      });

      this.indexList.items = this.indxList; // access index list in UserPreference component

      try {

        if (this.services.dataStore.getData("defaultIndex") != "") {
          let defaultIndex = this.services.dataStore.getData("defaultIndex").split(',');
          //console.log("defaultIndex",defaultIndex);

         this.indxListMaster.forEach((value, key) => {
          //console.log("defaultIndex[0]",data[0].indexName,"value",value.indexName,"data[1]",data[1].indexName);
          if(value.indexName == data[0].indexName) {
            this.firstIndx = value.key; 
          }
          if (value.indexName == data[1].indexName) {
            this.secondIndx = value.key;
          }
        });

        }
      } catch (error) {
        this.firstIndx = data[0].indexId;
        this.secondIndx = data[1].indexId;
      }

      //console.log("this.firstIndx",this.firstIndx);
      //console.log("data...",data);
      if (this.firstIndx == 0) {
        this.firstIndx = data[0].indexId;
      }
      if (this.secondIndx == 0) {
        this.secondIndx = data[1].indexId;
      }
    });
  }

  getIndexInitData() {
    this.marketService.getIndexInitData().subscribe((resp: any) => {
    //console.log('[%s] INDEXDETAILS RSP SUBS Received ', new Date(), resp);
      resp.forEach(data => {
        if (data.Symbol != null && data.Symbol != "" && data.Symbol != " ") {
          let indxObj = this.indxList.get(Number(data.Symbol));
          indxObj["indexColor"] = "default";
          if (data.IndexValue > indxObj["indexValue"]) {
            indxObj["indexColor"] = "indxIncr";
          } else if (data.IndexValue < indxObj["indexValue"]) {
            indxObj["indexColor"] = "indxDecr";
          }
          indxObj["indexValue"] = data.IndexValue;
          indxObj["changePercent"] = data.NetChangePercentage;
          indxObj["netChangeValue"] = data.NetChangeValue;
          this.indxList.set(Number(data.Symbol), indxObj);
        }
      });
    });
  }

  getIndex() {
    this.marketService.getIndex().subscribe((data: any) => {
      if (data != null && data.DataObject != null && data.DataObject.IndexValue != 0) {
        if (data.StockHeader.Symbol != null && data.StockHeader.Symbol != "" && data.StockHeader.Symbol != " ") {
          let indxObj = this.indxList.get(Number(data.StockHeader.Symbol));
          indxObj["indexColor"] = "default";
          if (data.DataObject.IndexValue > indxObj["indexValue"]) {
            indxObj["indexColor"] = "indxIncr";
          } else if (data.DataObject.IndexValue < indxObj["indexValue"]) {
            indxObj["indexColor"] = "indxDecr";
          }
          indxObj["indexValue"] = data.DataObject.IndexValue;
          indxObj["changePercent"] = data.DataObject.NetChangePercentage;
          indxObj["netChangeValue"] = data.DataObject.NetChangeValue;
          this.indxList.set(Number(data.StockHeader.Symbol), indxObj);
        }
      }
    });
  }

  getIndexDetails() {
    this.marketService.getIndexDetails().subscribe((data: any) => {
       //console.log('INDEXDETAILS Received... ', new Date(), data);
      if (data != null && data.DataObject != null && data.DataObject.IndexValue != 0) {
        if (data.StockHeader.Symbol != null && data.StockHeader.Symbol != "" && data.StockHeader.Symbol != " ") {
          let indxObj = this.indxList.get(Number(data.StockHeader.Symbol));
          indxObj["indexColor"] = "default";
          if (data.DataObject.IndexValue > indxObj["indexValue"]) {
            indxObj["indexColor"] = "indxIncr";
          } else if (data.DataObject.IndexValue < indxObj["indexValue"]) {
            indxObj["indexColor"] = "indxDecr";
          }
            //console.log('INDEXDETAILS Receiv iffff xxxxx' ,data.DataObject.IndexValue);
          indxObj["indexValue"] = data.DataObject.IndexValue;
          indxObj["changePercent"] = data.DataObject.NetChangePercentage;
          indxObj["netChangeValue"] = data.DataObject.NetChangeValue;
          //console.log('INDEXDETAILS Receiv iffff indxObj' ,indxObj);
          this.indxList.set(Number(data.StockHeader.Symbol), indxObj);
        }
      }
    });
  }

  getMarketStats() {
    this.marketService.getMarketStats().subscribe((data: any) => {
      //console.log("MarketStats Received ",data);
      //console.log("product..>>",this.displayProduct);
      //console.log("mdentrytype..>>",data.MDEntryType);
      if(this.displayProduct == "COMDERV" && data.MDEntryType=="C") {
          this.totalVolume = data.TotalVolume;
          this.totalTurnOver = data.TotalTurnover;
      }
      else if (this.displayProduct.includes("EQUITY") && data.MDEntryType=="0") {
          this.totalVolume = data.TotalVolume;
          this.totalTurnOver = data.TotalTurnover;
       }
      else if(this.displayProduct == "FUTOPT" && data.MDEntryType=="F") {
          this.totalVolume = data.TotalVolume;
          this.totalTurnOver = data.TotalTurnover;
      }
      
      /*this.totalVolume = data.TotalVolume;
      this.totalTurnOver = data.TotalTurnover;*/
    });
  }

  getMarketPhase() {
    //console.log("PHASE Inside getMarketPhase in landing");
    //SR commenting
    this.marketService.getMarketPhase().subscribe((data: any) => {

     
      //console.log("PHASE data",data);
      if(data.Board==CONSTANTS.Normal && data.Product == this.displayProduct){
        this.marketPhaseEquity = "EQUITY: " + data.Status;
      }
      if(data.Board==CONSTANTS.Normal && data.Product == this.displayProduct){
        this.marketPhaseFutopt = "FUTOPT: " + data.Status;
      }
      if(data.Board==CONSTANTS.Normal && data.Product == this.displayProduct){
        this.marketPhaseComderv = "COMDERV: " + data.Status;
      }

      this.services.dataStore.currentMessage.subscribe(message => {
        this.displayProduct = message;
        });

        //console.log("PHASE displayProductthis.",this.displayProduct);
        if(this.displayProduct == "FUTOPT"){
          //this.mfequityderivative = this.marketPhaseEquity +" / "+ this.marketPhaseFutopt;
          this.mfequityderivative = this.marketPhaseFutopt;
          this.marketPhase = this.mfequityderivative;
        }else if (this.displayProduct == "COMDERV"){
          this.mfcommodity = this.marketPhaseComderv;
          this.marketPhase = this.mfcommodity;
        }else if(this.displayProduct == "EQUITY"){
          this.mfequity = this.marketPhaseEquity;
          this.marketPhase = this.mfequity;
        }
        /*else{
          this.mfall =  this.marketPhaseEquity +"/"+ this.marketPhaseFutopt+"/"+ this.marketPhaseComderv ;
          this.marketPhase = this.mfall;
        }*/ //commented by shanmuga priya
    });
  }

}
